import React from "react";
import Header from "../components/Header";
import CarDetails from "../components/produs/CarDetails";
import Footer from "../components/Footer";

const CarPage = () => {
  return (
    <div>
      <Header />
      <CarDetails />
        <Footer/>
    </div>
  );
}

export default CarPage;
